module.exports = __webpack_public_path__ + "images/card-8be551.svg";